import {
  PAYMENT_METHODS,
  PROMOTION_DURATION,
  PROMOTION_TYPE,
  PROMOTION_TYPE_AND_DURATION_TO_VALUE,
} from '../constants/payment.constants';
import { formatMoney } from './currency';

export const getPaymentMethods = (isPrivateUser, intl) =>
  isPrivateUser
    ? [
        {
          value: PAYMENT_METHODS.PRIVATE.MONTHLY,
          price: '9,50 EUR',
          planDescription: intl.formatMessage({
            id: 'General.paymentMethods.description.monthlyDescription',
          }),
          descriptionList: [
            intl.formatMessage({
              id: 'General.paymentMethods.description.adOnlineQuickly',
            }),
            intl.formatMessage({ id: 'General.paymentMethods.description.allPromotionsAccess' }),
            intl.formatMessage({ id: 'General.paymentMethods.description.autoRenewalControl' }),
          ],
        },
        {
          value: PAYMENT_METHODS.PRIVATE.QUARTERLY,
          price: '24,50 EUR',
          isSmartChoice: true,
          planDescription: intl.formatMessage({
            id: 'General.paymentMethods.description.quarterlyDescription',
          }),
          descriptionList: [
            intl.formatMessage({
              id: 'General.paymentMethods.description.longerVisibilityLowerPrice',
            }),
            intl.formatMessage(
              { id: 'General.paymentMethods.description.active13Weeks' },
              { value: 13 }
            ),
            intl.formatMessage({ id: 'General.paymentMethods.description.reminderOnTime' }),
          ],
        },
        {
          value: PAYMENT_METHODS.PRIVATE.SEMI_ANNUAL,
          price: '39,50 EUR',
          isBestChoice: true,
          planDescription: intl.formatMessage({
            id: 'General.paymentMethods.description.semiAnualDescription',
          }),
          descriptionList: [
            intl.formatMessage(
              { id: 'General.paymentMethods.description.saveEuro' },
              { value: 22 }
            ),
            intl.formatMessage(
              { id: 'General.paymentMethods.description.activeWeeks' },
              { value: 26 }
            ),
            intl.formatMessage({
              id: 'General.paymentMethods.description.setUnavailableAfterSale',
            }),
          ],
        },
      ]
    : [
        {
          value: PAYMENT_METHODS.BUSINESS.BASIC,
          price: '25,- EUR *',
          descriptionList: [
            intl.formatMessage({
              id: 'General.paymentMethods.description.business-basic.benefit1',
            }),
            intl.formatMessage({
              id: 'General.paymentMethods.description.business-basic.benefit2',
            }),
            intl.formatMessage({
              id: 'General.paymentMethods.description.business-basic.benefit3',
            }),
            intl.formatMessage({
              id: 'General.paymentMethods.description.business-basic.benefit4',
            }),
          ],
          footnote: intl.formatMessage({
            id: 'General.paymentMethods.description.business-basic.footnote',
          }),
        },
        {
          value: PAYMENT_METHODS.BUSINESS.PRO,
          price: '40,- EUR *',
          descriptionList: [
            intl.formatMessage({ id: 'General.paymentMethods.description.business-pro.benefit1' }),
            intl.formatMessage({ id: 'General.paymentMethods.description.business-pro.benefit2' }),
            intl.formatMessage({ id: 'General.paymentMethods.description.business-pro.benefit3' }),
            intl.formatMessage({ id: 'General.paymentMethods.description.business-pro.benefit4' }),
          ],
          footnote: intl.formatMessage({
            id: 'General.paymentMethods.description.business-pro.footnote',
          }),
        },
      ];

export const getPromotionOptions = (intl, prices, duration = PROMOTION_DURATION.WEEKLY) => [
  {
    value: PROMOTION_TYPE.RECURRING.HIGHLIGHT,
    price: formatMoney(
      intl,
      prices?.[PROMOTION_TYPE_AND_DURATION_TO_VALUE[PROMOTION_TYPE.RECURRING.HIGHLIGHT][duration]]
    ),
    isSmartChoice: true,
    planDescription: intl.formatMessage({
      id: 'General.promotion.description.planDescription1',
    }),
    descriptionList: [
      intl.formatMessage({
        id: 'General.promotion.description.plan1.benefit1',
      }),
      intl.formatMessage({
        id: 'General.promotion.description.plan1.benefit2',
      }),
      intl.formatMessage({
        id: 'General.promotion.description.plan1.benefit3',
      }),
    ],
  },
  {
    value: PROMOTION_TYPE.RECURRING.RECOMMENDED,
    price: formatMoney(
      intl,
      prices?.[PROMOTION_TYPE_AND_DURATION_TO_VALUE[PROMOTION_TYPE.RECURRING.RECOMMENDED][duration]]
    ),
    planDescription: intl.formatMessage({
      id: 'General.promotion.description.planDescription2',
    }),
    descriptionList: [
      intl.formatMessage({
        id: 'General.promotion.description.plan2.benefit1',
      }),
      intl.formatMessage({
        id: 'General.promotion.description.plan2.benefit2',
      }),
      intl.formatMessage({
        id: 'General.promotion.description.plan2.benefit3',
      }),
    ],
  },
  {
    value: PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED,
    price: formatMoney(
      intl,
      prices?.[
        PROMOTION_TYPE_AND_DURATION_TO_VALUE[PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED][
          duration
        ]
      ]
    ),
    isBestChoice: true,
    planDescription: intl.formatMessage({
      id: 'General.promotion.description.planDescription3',
    }),
    descriptionList: [
      intl.formatMessage({
        id: 'General.promotion.description.plan3.benefit1',
      }),
      intl.formatMessage({
        id: 'General.promotion.description.plan3.benefit2',
      }),
      intl.formatMessage({
        id: 'General.promotion.description.plan3.benefit3',
      }),
    ],
  },
];

export const getBoostOptions = intl => [
  {
    value: PROMOTION_TYPE.ONE_TIME.BOOST,
    price: '1,95 EUR',
    planDescription: intl.formatMessage({
      id: 'AdBoostModal.planDescription',
    }),
    descriptionList: [
      intl.formatMessage({
        id: 'AdBoostModal.benefit1',
      }),
      intl.formatMessage({
        id: 'AdBoostModal.benefit2',
      }),
    ],
  },
];
